const categoryList = [
  {
    name: "Gestão de Negócios",
    background: "#1fa1f2",
  },
  {
    name: "Dicas de Beleza",
    background: "#d7a2ca",
  },
  {
    name: "Novas Funcionalidades",
    background: "#77cf40",
  },
  {
    name: "Tutoriais",
    background: "#f97b69",
  },
  {
    name: "Outros",
    background: "#13bab2",
  },
]

export default categoryList
